class ElectorKeyValidator {
    static instance;
    static VALID_LENGTH = 18;
    static VALID_FORMAT = /^([A-Z]{6})(\d{6})(\d{2})(H|M)(\d{3})$/i;
    static VALID_SEX = ['H', 'M'];

    static getInstance() {
        if (!ElectorKeyValidator.instance) {
            ElectorKeyValidator.instance = new ElectorKeyValidator();
        }
        return ElectorKeyValidator.instance;
    }

    validate(key) {
        console.log("Validando clave:", key);

        if (key.length !== ElectorKeyValidator.VALID_LENGTH) {
            console.log("Longitud inválida:", key.length, "(Se esperaban", ElectorKeyValidator.VALID_LENGTH, "caracteres)");
            return false;
        }

        if (!ElectorKeyValidator.VALID_FORMAT.test(key)) {
            console.log("Formato inválido:", key);
            return false;
        }

        const birthDate = key.slice(6, 12);
        const sex = key[14];
        const checkDigit = parseInt(key.slice(15, 16));

        console.log("Fecha de nacimiento extraída:", birthDate);
        console.log("Sexo extraído:", sex);
        console.log("Dígito verificador extraído:", checkDigit);

        if (!this.isValidDate(birthDate)) {
            console.log("Fecha de nacimiento inválida:", birthDate);
            return false;
        }

        if (!ElectorKeyValidator.VALID_SEX.includes(sex.toUpperCase())) {
            console.log("Caracter de sexo inválido:", sex, "(Se esperaba H o M)");
            return false;
        }

        const calculatedCheckDigit = this.calculateCheckDigit(key);
        console.log("Dígito verificador calculado:", calculatedCheckDigit);

        if (checkDigit !== calculatedCheckDigit) {
            console.log("Error en el dígito verificador. Se esperaba:", calculatedCheckDigit, "Se encontró:", checkDigit);
            return false;
        }

        console.log("Clave válida!");
        return true;
    }

    isValidDate(dateStr) {
        const year = parseInt(dateStr.slice(0, 2));
        const month = parseInt(dateStr.slice(2, 4));
        const day = parseInt(dateStr.slice(4, 6));

        if (month < 1 || month > 12 || day < 1 || day > 31) {
            console.log("Mes o día inválido en la fecha:", dateStr);
            return false;
        }

        const currentYear = new Date().getFullYear();
        const century = Math.floor(currentYear / 100) * 100;
        const fullYear = year > (currentYear % 100) ? (century - 100) + year : century + year;
        const date = new Date(fullYear, month - 1, day);

        const isValid = date.getFullYear() === fullYear && date.getMonth() === month - 1 && date.getDate() === day;
        console.log("Validación de fecha de nacimiento:", isValid);
        return isValid;
    }

    calculateCheckDigit(key) {
        let sum = 0;
        const first14 = key.slice(0, 14).toUpperCase();

        console.log("Calculando dígito verificador para:", first14);

        for (let pos = 0; pos < first14.length; pos++) {
            let valInt;
            const val = first14[pos];

            console.log("Evaluando carácter:", val);

            if (/[0-9]/.test(val)) {
                valInt = parseInt(val);
            } else {
                valInt = val.charCodeAt(0) - 64;
            }
            console.log("Valor entero del carácter:", valInt);

            valInt *= (pos % 2 === 0) ? 3 : -3;
            console.log("Valor basado en si es entero valor * (3 o -3):", valInt);

            console.log("Valor previo de la suma:", sum);
            sum += valInt;
            console.log("Valor nuevo de la suma:", sum);
        }

        let checkDigit = 10 - (sum - (Math.floor(sum / 10) * 10));
        if (checkDigit === 10) checkDigit = 0;
        console.log("Dígito verificador final calculado:", checkDigit);
        return checkDigit;
    }
}

export default ElectorKeyValidator.getInstance();
